import { JSX } from "@emotion/react/jsx-runtime";
import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { DynamicContentText } from "../DynamicContentComponent";

export const DynamicTextSubtitle = ({ text, childElements }: DynamicContentText): JSX.Element => {
    return <Typography variant="h2" component="p" align="left"  marginTop="25px">
      {text}
      {childElements || ''}
    </Typography>
}